// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'
import qmdLogo from '../../../images/common/quickmd-main-logo.png'

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  headerText: {
    color: '#141414',
    textAlign: 'right',
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '400',
  },
  image: {
    alignSelf: 'flex-start',
    width: 120,
    height: 40,
  },
  section: {
    alignItems: 'flex-end',
  },
})
const PatientChartsPrintedFriendlyHeader = () => (
  <View style={styles.header}>
    <View style={styles.section}>
      {/*
       // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered */}
      <Image href={qmdLogo} style={styles.image} alt='logo' />
    </View>
    <View style={styles.section}>
      <Text style={styles.headerText}>QuickMD Corporate Office</Text>
      <Text style={styles.headerText}>3415 South Sepulveda Blvd. 10th Floor</Text>
      <Text style={styles.headerText}>Los Angeles, CA, 90034</Text>
      <Text style={styles.headerText}>https://support.quick.md/</Text>
    </View>
  </View>
)

export default PatientChartsPrintedFriendlyHeader
